// extracted by mini-css-extract-plugin
export default {"bankList":"OfferSummary_bankList__2x40T"};